import { Injectable } from '@angular/core';
import { isNullOrUndefined } from '../functions/helper-functions';

@Injectable({
  providedIn: 'root',
})
export class SvcFunctionsHelper {
  constructor() {}

  randomNumber(min = 1, max = 9999): number {
    const number = Math.floor(Math.random() * max);

    return Math.max(number, min);
  }

  onlyNumbers(text: string): string {
    if (!isNullOrUndefined(text)) return text.replace(/[^\d]/g, '');
    return '';
  }

  onlyAlphaNumeric(text: string): string {
    if (!isNullOrUndefined(text)) return text.replace(/[^a-zA-Z0-9]+/g, '');
    return '';
  }

  onlyAlpha(text: string): string {
    if (!isNullOrUndefined(text)) return text.replace(/[^a-zA-Z]+/g, '');
    return '';
  }

  onlyNumberAndToFloat(text: string): number {
    if (text) {
      const strNumber = text.replace(/[^\d.\d]/g, '');
      const number = parseFloat(strNumber);
      if (!isNaN(number)) return number;
    }
    return 0;
  }

  removeAccents(text: string): string {
    return text ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : '';
  }

  copy(obj: any): string {
    if (obj) return JSON.parse(JSON.stringify(obj));
    else return obj;
  }

  copyToClipboard(inputElement): void {
    inputElement.focus();
    inputElement.select();
    if (!navigator.clipboard) {
      const successful = document.execCommand('copy');
    } else {
      navigator.clipboard.writeText(inputElement?.value);
    }
  }

  getDiffOfDate(dateBegin: Date, dateEnd: Date, returnType: 'days' | 'hours' | 'minutes' | 'seconds' = 'days'): number {
    if (dateBegin && dateEnd) {
      let delta = Math.abs(dateEnd.getTime() - dateBegin.getTime()) / 1000;

      const days = Math.floor(delta / 86400);
      delta -= days * 86400;

      const hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      const minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      const seconds = Math.floor(delta % 60);

      if (returnType === 'days') return days;
      else if (returnType === 'hours') return hours;
      else if (returnType === 'minutes') return minutes;
      else if (returnType === 'seconds') return seconds;
    }

    return 0;
  }

  public decodeBase64(text: string): string {
    return atob(text);
  }

  public encodeBase64(text: string): string {
    return btoa(text);
  }

  public uid(): string {
    const pad4 = (num: number): string => {
      let ret: string = num.toString(16);
      while (ret.length < 4) {
        ret = '0' + ret;
      }
      return ret;
    };

    const random4 = (): string => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };

    if (typeof window !== 'undefined' && typeof window.crypto !== 'undefined' && typeof window.crypto.getRandomValues !== 'undefined') {
      const buf: Uint16Array = new Uint16Array(8);
      window.crypto.getRandomValues(buf);
      return pad4(buf[0]) + pad4(buf[1]) + '-' + pad4(buf[2]) + '-' + pad4(buf[3]) + '-' + pad4(buf[4]) + '-' + pad4(buf[5]) + pad4(buf[6]) + pad4(buf[7]);
    } else return random4() + random4() + '-' + random4() + '-' + random4() + '-' + random4() + '-' + random4() + random4() + random4();
  }

  removeHtml(html: string): string {
    return html?.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/g, ' ') ?? '';
  }
}
